/** @module csi/card/AttributeCardRefRenderer */
define([
	"dojo/_base/declare",
	"dojo/when",
	"underscore",
	"csi/card/_base",
	"csi/card/AttributeCard",
	"csi/heading/Ref",
	"csi/html",
	"csi/xml"
], function(declare, when, _, csiCard, AttributeCard, Ref, html, xml) {

	return declare(Ref, {
		/**
		 * @override
		 * Add dependency paths for attribute card if type is known
		 */
		addRendererDependencyPaths: function(h, paths) {
			var destClass = h._rca && h._rca.getDestinationClass();
			var destType = destClass && destClass.getType();
			if (destType) {
				csiCard.getAttributeCardPaths(destType, h.getQueryPath(), paths);
			}
		},

		/**
		 * Extension point to add parameters for AttributeCard widget per instance, such as anchorHref or anchorText
		 * @param {Context} ctx
		 * @param {Object} params 
		 */
		onAttributeCardParams: function(ctx, params) { },

		/**
		 * Extension point to add parameters for AttributeCard when rendered in tooltip
		 * @param {Context} ctx
		 * @param {Object} params 
		 */
		onTooltipAttributeCardParams: function(ctx, params) { },

		/**
		 * @override
		 * Render slim attribute card for referenced node
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const path = xml.path(h.m_id);
			const params = {
				ctx: ctx,
				slim: true
			};

			if (ctx.push(path)) {
				_.extend(params, csiCard.getAttributeCardSpecs(ctx.getNodeType()));
				this.onAttributeCardParams(ctx, params);
				new AttributeCard(params).placeAt(refNode);
				ctx.pop();
				return true;
			}

			return false;
		},

		/**
		 * @override
		 * Render detailed attribute card in tooltip for referenced node after querying for necessary data
		 */
		toTooltip: function(ctx, h, tooltip) {
			const self = this;
			const path = xml.path(h.m_id);

			if (ctx.push(path)) {
				return when(csiCard.getAttributeCardDependencies(ctx), function() {
					const div = html.create("div");
					const params = {
						ctx: ctx,
						isTooltip: true
					};

					_.extend(params, csiCard.getAttributeCardSpecs(ctx.getNodeType()));
					self.onTooltipAttributeCardParams(ctx, params);
					new AttributeCard(params).placeAt(div);
					tooltip.setContent(div);
					ctx.pop();
				});
			}
		}
	});
});